import axios from "axios";
import GLOBAL_CONFIG from "../config/config";
function campaignServices() {

    const ServicesUrl = () => {
        var hostName = window.location.hostname,
            isProd = hostName.toLowerCase().indexOf('milka.at') > -1 ? true : false,
            isHiddenProd = hostName.toLowerCase().indexOf('run.app') > -1 ? true : false,
            isStage = hostName.toLowerCase().indexOf('mdlzapps.cloud') > -1 ? true : false;

            if (isProd) {
                return 'https://api.gluecksrad.milka.at';
            }
            if (isStage) {
                return 'https://api.gluecksrad.milka-stg.hosting.plutex.de';
            }
            if (isHiddenProd) {
                return 'https://api.gluecksrad.milka.hosting.plutex.de';
            }
              return 'https://api.gluecksrad.milka-stg.hosting.plutex.de'
    }

    const _BASE_URL = "/api";
    const _NEWSLETTER = GLOBAL_CONFIG.Settings.defaultSite + '/NewsletterSub';

    // const participation = ({ retailer, data }) => {
    //     return axios({
    //         method: "POST",
    //         url: `${_BASE_URL}/${retailer === "muller" ? "mueller" : retailer}/Participate`,
    //         data: data,
    //         headers: { 'Content-Type': 'multipart/form-data' }
    //     })
    // }



    // const status = ({ retailer }) => {
    //     const campaignUrl = ServicesUrl({ retailer });
    //     if (retailer === 'alle') retailer = 'Nascherei'
    //     // const currentUrl = window.location.href;
    //     const url = new URL(window.location.href);
    //     let urlGate = null;

    //     if (retailer === 'Nascherei' && url.pathname.includes('gewinne') || retailer === 'Nascherei' && url.pathname.includes('gift')) {
    //         urlGate = campaignUrl + `/CampaignStatusEaster`;
    //     } else {
    //         urlGate = campaignUrl + `/CampaignStatus` + retailer.replace(/^./, retailer[0].toUpperCase())
    //     }

    //     return axios({
    //         method: "GET",
    //         // url: campaignUrl + `/CampaignStatus` + retailer.replace(/^./, retailer[0].toUpperCase())
    //         url: urlGate
    //     })
    // }

    const status = () => {
        const campaignUrl = ServicesUrl();
        return axios({
            method: "GET",
            url: campaignUrl + `/CampaignStatusGluecksrad` 
        })
    }

    const participation = ({ data }) => {
        const campaignUrl = ServicesUrl();
        return axios({
            method: "POST",
            url: campaignUrl + `/Gluecksrad/SubmitParticipation`,
            data: data,
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    }

    const iban = ({ data }) => {
        const campaignUrl = ServicesUrl();
        return axios({
            method: 'POST',
            url : campaignUrl + '/Gluecksrad/SubmitIBAN',
            data: data,     
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    }

    const checkParticipant = (pid, cid) => {
        const campaignUrl = ServicesUrl();
        return axios({
            method: 'GET',
            url: campaignUrl + `/Gluecksrad/GetCashbackInfo?pid=${pid}&cid=${cid}`
        })
    }

    // const participation = ({ data, retailer }) => {
    //     return axios({
    //         method: "POST",
    //         url: `${ServicesUrl()}/Nascherei/SubmitParticipation`,
    //         data: data,
    //         headers: { 'Content-Type': 'multipart/form-data' }
    //     })
    // }

    const receipt = ({ data, retailer }) => {
        return axios({
            method: "POST",
            url: `${ServicesUrl({ retailer })}/Nascherei/SubmitReceipt`,
            data: data,
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    }


    const newsletterSubscribe = ({ retailer, data }) => {
        return axios({
            method: "POST",
            url: `${_BASE_URL}/${retailer === "muller" ? "mueller" : retailer}/newsletterSubscribe`,
            data: data
        });
    }
    const newsletterSub = (_data) => {
        return axios({
            method: 'POST',
            url: `${_BASE_URL}/${_NEWSLETTER}`,
            data: _data,
            headers: { 'Content-Type': 'application/json; charset=utf-8' },
        })
    }

    const supportingProfile = (_data) => {
        return axios({
            method: 'post',
            url: `https://milka-supporting.azurewebsites.net/supporting/crm/profile`,
            data: _data
        })
    }

    return {
        Status: status,
        Participate: participation,
        Receipt: receipt,
        NewsletterSubscribe: newsletterSub,
        SupportingProfile: supportingProfile,
        Iban: iban,
        CheckParticipant: checkParticipant,
    }
}

const CampaignServices = campaignServices();

export default CampaignServices;